import React from 'react';
import comuni from '../data/comuni-cap.json';

const normalize = value => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export default function ComuneAutocomplete({ value = '', onChange, onSelect, placeholder = 'Città', ariaLabel, includeProvince = false, required = false }) {
  const [open, setOpen] = React.useState(false);
  const matches = React.useMemo(() => {
    const query = normalize(includeProvince ? value.replace(/\s*\([A-Z]{2}\)\s*$/i, '') : value);
    if (query.length < 2) return [];
    return comuni
      .filter(comune => normalize(comune.nome).startsWith(query))
      .slice(0, 8);
  }, [value, includeProvince]);

  const choose = comune => {
    onChange(includeProvince && comune.sigla ? `${comune.nome} (${comune.sigla})` : comune.nome);
    onSelect?.(comune);
    setOpen(false);
  };

  const handleBlur = () => {
    const exact = comuni.filter(comune => normalize(comune.nome) === normalize(includeProvince ? value.replace(/\s*\([A-Z]{2}\)\s*$/i, '') : value));
    if (exact.length === 1) choose(exact[0]);
    window.setTimeout(() => setOpen(false), 120);
  };

  return <div className="comune-autocomplete-field">
    <input type="text" aria-label={ariaLabel || placeholder} placeholder={placeholder} value={value} required={required}
      autoComplete="off" onFocus={() => setOpen(true)} onBlur={handleBlur}
      onChange={event => { onChange(event.target.value); setOpen(true); }} />
    {open && matches.length > 0 && <ul className="comune-suggestions" role="listbox" aria-label={`Suggerimenti per ${placeholder}`}>
      {matches.map(comune => <li key={`${comune.nome}-${comune.sigla}`}>
        <button type="button" onMouseDown={event => event.preventDefault()} onClick={() => choose(comune)}>
          <strong>{comune.nome}</strong><span>{comune.provincia} ({comune.sigla}){comune.cap?.length ? ` · CAP ${comune.cap.join(', ')}` : ''}</span>
        </button>
      </li>)}
    </ul>}
  </div>;
}
